export const INFO_SHOW = 'INFO_SHOW';
export const infoShow = (key, message, title = null) => ({type: INFO_SHOW, message, title, key});

export const INFO_CLOSE = 'INFO_CLOSE';
export const infoClose = key => ({type: INFO_CLOSE, key});



/** WEBPACK FOOTER **
 ** ./src/members/state/info/actions.js
 **/